// @ts-nocheck
import { ref } from 'vue';
import editorInlineData from '@base/data/editorInlineData.json';

// Polyfill for safari v14
if (!Object.hasOwn) {
  Object.hasOwn = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);
}

const typograf = (textData) => {
  let text = textData;

  // Замена обычных кавычек на кавычки-ёлочки
  text = text.replace(/"([^"]*)"/g, '«$1»');

  // Другие типографические преобразования
  text = text.replace(/--/g, '—'); // Замена двойного дефиса на тире

  // Замена переносов строк на <br>
  text = text.replace(/\r\n|\n/g, '<br>');

  text = text.split(' ').map((word, index, array) => {
    if (word.length < 3 && /^[\p{L}]+$/u.test(word) && index < array.length - 1) {
      return `${word}&nbsp;`;
    }
    return word;
  }).join(' ');

  return text;
};

const addEditorStyles = () => {
  const styles = `
      
.editor-inline--show .editor-inline__circle {
  pointer-events: auto;
}

.editor-inline--show .editor-inline__label {
  opacity: 1;
}

.editor-inline--hide .editor-inline__circle {
  pointer-events: none;
  opacity: 0 !important;
}

.editor-inline--hide .editor-inline__label {
  opacity: 0.5;
}
  
.editor-inline__loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 15000;
}

.editor-inline__loader {
  width: 6vh;
  height: 6vh;
  z-index: 10;
  border-radius: 50%;
  background-color: #FFCC00;
  animation: pulse .9s infinite ease-in-out;
}

.editor-inline__modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
}

.editor-inline__mobal-content {
  display: flex;
  width: 90%;
  max-width: 80vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 1.2vh;
  padding: 7vh 3vh 3vh 3vh;
}

.editor-inline__mobal-content--list {
  display: block;
  max-width: 80vw;
  max-height: 80vh;
  overflow: auto;
  color: #FFFFFF;
}

.editor-inline__textarea-wrapper {
  display: flex;
  align-items: center;
}

.editor-inline__textarea {
  width: 50vh;
  font-size: 2.2vh;
  padding: 1vh 2vh;
  border: 2px solid #FFCC00;
  margin-right: 2vh;
}

.editor-inline__title {
  font-size: 3vh;
  margin-bottom: 3vh;
  color: #FFCC00;
  text-align: center;
}

.editor-inline__buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5vh;
}

.editor-inline__button {
  cursor: pointer;
  font-size: 3vh;
  margin-right: 4vh;
  padding: 1.4vh 2.8vh;
  background-color: #FFCC00;
  color: #FFFFFF;
  border: 2px solid #FFCC00;
}

.editor-inline__circle {
  position: absolute;
  z-index: 5000;
  width: 1.3rem;
  height: 1.3rem;
  border-radius: 50%;
  background-color: #FFCC00;
  opacity: 0.5;
  cursor: pointer;
  display: none;
}

.editor-inline__button:last-child {
  margin-right: 0;
}

.editor-inline__button--white {
  background-color: #FFFFFF;
  color: #FFCC00;
}

.editor-inline__label {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  transition: transform 0.3s ease-in-out;
  border-right: 0.3rem solid #FFCC00;
  width: 3rem;
  color: #FFCC00;
  cursor: pointer;
  z-index: 1000;
}
.editor-inline__label:hover {
  transform: scale(1.2);
}

.editor-inline__label--close {
  top: 37vh;
  left: 0;
}

.editor-inline__label--list {
  top: 46vh;
  left: 0;
}

.editor-inline__label--toggle {
  top: 55vh;
  left: 0;
}

.editor-inline__label--refresh {
  top: 64vh;
  left: 0;
}

.editor-inline__close {
  position: absolute;
  top: -0.3rem;
  right: 0.5rem;
  font-size: 3rem;
  color: #FFFFFF;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
}

.editor-inline__close:hover {
  transform: scale(1.2);
}
  `;

  const styleSheet = document.createElement('style');
  styleSheet.type = 'text/css';
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
};

const showEditorKey = 'editor-inline__showEditor';
const baseUrl = import.meta.env.BASE_URL;
const isLocalDev = import.meta.env.DEV;
const isDemoDev = window.location.href.indexOf('specials-stage') !== -1;

const isProduction = !isLocalDev && !isDemoDev;
const isShowEditorLocal = localStorage.getItem(showEditorKey);
const isShowEditor = isShowEditorLocal === 'true';

const store = {
  isLoading: false,
  isAuthChecked: false,
  data: null,
  slug: 'akinfeev',
  preloadElements: [],
  color: '#FFCC00',
  currentBinding: null,
  modalContainer: null,
  loaderContainer: null,
  globalProperties: null,
  baseUrl,
  isLocalDev,
  isDemoDev,
  isProduction,
  isAdmin: false,
  isShowEditor,
  backOnCloseModal: null,

  handleResize() {
    document.querySelectorAll('[data-editor-key]').forEach((el) => {
      store.setCirclePosition(el, el.editorPointElement);
    });
  },

  initEditor() {
    if (!this.isAdmin) {
      return;
    }
    addEditorStyles();

    const labelClose = document.createElement('div');
    labelClose.className = 'editor-inline__label editor-inline__label--close';
    labelClose.innerHTML = '<span>&times;</span>';
    labelClose.onclick = () => {
      this.closeEditor();
    };

    const labelList = document.createElement('div');
    labelList.className = 'editor-inline__label editor-inline__label--list';
    labelList.innerHTML = '<span>&vellip;</span>';
    labelList.onclick = () => {
      this.renderListModal();
    };

    const labelToggle = document.createElement('div');
    labelToggle.className = 'editor-inline__label editor-inline__label--toggle';
    labelToggle.innerHTML = '<span>&#248;</span>';
    labelToggle.onclick = () => {
      this.toggleEditor();
    };

    const labelRefresh = document.createElement('div');
    labelRefresh.className = 'editor-inline__label editor-inline__label--refresh';
    labelRefresh.innerHTML = '<span>&#8635;</span>';
    labelRefresh.onclick = () => {
      this.refreshData();
    };

    const loaderContainer = document.createElement('div');
    loaderContainer.className = 'editor-inline__loader-wrapper';

    const loader = document.createElement('div');
    loader.className = 'editor-inline__loader';
    loaderContainer.appendChild(loader);
    loaderContainer.style.visibility = 'hidden';
    this.loaderContainer = loaderContainer;

    document.body.appendChild(labelClose);
    document.body.appendChild(labelList);
    document.body.appendChild(labelToggle);
    document.body.appendChild(labelRefresh);
    document.body.appendChild(loaderContainer);

    window.addEventListener('resize', this.handleResize);

    if (this.isShowEditor) {
      document.body.classList.add('editor-inline--show');
    }
    else {
      document.body.classList.add('editor-inline--hide');
    }
  },

  closeEditor() {
    this.isAdmin = false;
    document.querySelectorAll('[data-editor-key]').forEach((el) => {
      store.removeObserver(el);
      store.removeCircle(el);
    });
    document.querySelectorAll('.editor-inline__label').forEach((el) => {
      el.remove();
    });

    window.removeEventListener('resize', this.handleResize);
  },

  toggleEditor() {
    this.isShowEditor = !this.isShowEditor;
    localStorage.setItem(showEditorKey, this.isShowEditor);

    if (this.isShowEditor) {
      document.body.classList.add('editor-inline--show');
      document.body.classList.remove('editor-inline--hide');
    }
    else {
      document.body.classList.add('editor-inline--hide');
      document.body.classList.remove('editor-inline--show');
    }
  },

  async checkAuth() {
    if (this.isLoading) {
      return null;
    }

    this.isAuthChecked = true;

    if (this.isLocalDev) {
      this.isAdmin = true;
      return null;
    }

    if (this.isProduction) {
      this.isAdmin = false;
      return null;
    }

    this.isLoading = true;

    try {
      let response = await fetch(`https://www.sports.ru/special/json-admin-backend/shared/can-edit/?slug=${this.slug}`, {
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      response = await response.json();
      this.isAdmin = response.canEdit;
      this.isLoading = false;

      return null;
    }
    catch (error) {
      console.error('Error check canEdit data:', error);
      this.isLoading = false;
      return null;
    }
  },

  addElement(el, binding) {
    this.preloadElements.push({ el, binding });
  },

  getPropertyByStringKey(key) {
    const keys = key.split('.');
    const obj = this.data;

    if (!obj) {
      return '';
    }

    let result = obj;

    keys.forEach((_, i) => {
      if (!Object.hasOwn(result, keys[i])) {
        result = keys[i];
      }
      else {
        result = result[keys[i]];
      }
    });

    return result;
  },

  setPropertyByStringKey(key, value) {
    const keys = key.split('.');
    const obj = this.data;

    if (!obj) {
      return;
    }

    let result = obj;

    keys.forEach((_, i) => {
      if (!Object.hasOwn(result, keys[i])) {
        return;
      }

      if (i === keys.length - 1) {
        result[keys[i]] = value;
        return;
      }

      result = result[keys[i]];
    });
  },

  showLoader() {
    this.isLoading = true;
    if (this.loaderContainer) {
      this.loaderContainer.style.visibility = 'visible';
    }
  },

  hideLoader() {
    this.isLoading = false;
    if (this.loaderContainer) {
      this.loaderContainer.style.visibility = 'hidden';
    }
  },

  async authAndGetData(globalProperties) {
    if (this.isProduction) {
      this.isAuthChecked = true;
    }
    if (!this.isAuthChecked) {
      await this.checkAuth();
      await store.initEditor();
    }
    await this.getData(globalProperties);
  },

  async getData(globalProperties, options = { isRefresh: false }) {
    if (this.isLoading) {
      return null;
    }

    const { isRefresh } = options;
    if (this.data && !isRefresh) {
      return this.data;
    }

    if (globalProperties) {
      this.globalProperties = globalProperties;
    }

    if (this.isProduction) {
      this.data = editorInlineData;
      this.globalProperties.$editorData.value = {
        ...this.data,
      };

      return this.data;
    }

    const baseJsonAdminUrl = 'https://www.sports.ru/special/json-admin-backend/';
    let url = `${baseJsonAdminUrl}${this.slug}/`;

    if (isRefresh) {
      url += '?refresh=true';
    }

    this.showLoader();

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      this.hideLoader();
      this.data = data;
      this.preloadElements.forEach(({ el, binding }) => {
        this.renderElement(el, binding);
      });

      this.globalProperties.$editorData.value = {
        ...this.data,
      };

      return data;
    }
    catch (error) {
      this.hideLoader();
      console.error('Error fetching JSON data:', error);
      return null;
    }
  },

  async setData(data) {
    const url = 'https://www.sports.ru/special/json-admin-backend/configuration/update-json';

    this.showLoader();

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
        credentials: 'include',
        body: JSON.stringify({
          json: data,
          slug: this.slug,
        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      this.hideLoader();

      return null;
    }
    catch (error) {
      this.hideLoader();
      console.error('Error saving JSON data:', error);
      return null;
    }
  },

  async refreshData() {
    await this.getData(null, { isRefresh: true });
  },

  handleKeyPress(event) {
    switch (event.key) {
      case 'Escape':
        // Закрытие модального окна
        this.closeModal();
        break;
      default:
        break;
    }
  },

  closeModal() {
    if (this.modalContainer) {
      this.modalContainer.remove();
    }
    document.removeEventListener('keydown', this.handleKeyPress.bind(this));
    this.currentBinding = null;

    if (this.backOnCloseModal === 'list') {
      this.renderListModal();
    }

    this.backOnCloseModal = null;
  },

  async saveAndCloseModal(binding, value) {
    this.setPropertyByStringKey(binding.value, value);
    this.globalProperties.$editorData.value = {
      ...this.data,
    };
    await this.setData(this.data);

    const elements = document.querySelectorAll('[data-editor-key]');

    elements.forEach((el) => {
      const elBinding = el.getAttribute('data-editor-key');

      el.innerHTML = this.getPropertyByStringKey(elBinding);
      this.setCirclePosition(el, el.editorPointElement);
    });

    this.closeModal();
  },

  renderModal(binding, backOnCloseModal = null) {
    this.backOnCloseModal = backOnCloseModal;
    this.currentBinding = binding;
    const text = this.getPropertyByStringKey(binding.value);
    document.addEventListener('keydown', this.handleKeyPress.bind(this));

    const modalContainer = document.createElement('div');
    this.modalContainer = modalContainer;
    modalContainer.className = 'editor-inline__modal';
    modalContainer.onclick = (e) => {
      e.stopPropagation();
      this.closeModal();
    };

    const modalContent = document.createElement('div');
    modalContent.className = 'editor-inline__mobal-content';
    modalContent.onclick = (e) => {
      e.stopPropagation();
    };

    const closeIcon = document.createElement('div');
    closeIcon.className = 'editor-inline__close';
    closeIcon.innerHTML = '<span>&times;</span>';
    closeIcon.onclick = () => {
      this.closeModal();
    };

    const textareaContainer = document.createElement('div');
    textareaContainer.className = 'editor-inline__textarea-wrapper';

    const title = document.createElement('div');
    title.className = 'editor-inline__title';
    title.innerText = binding.value;

    const textarea = document.createElement('textarea');
    textarea.className = 'editor-inline__textarea';
    textarea.value = text;
    textarea.rows = 4;

    const typografButtonWrapper = document.createElement('div');
    const typografButton = document.createElement('button');
    typografButton.className = 'editor-inline__button';
    typografButton.innerText = 'Типограф';
    typografButton.onclick = (e) => {
      e.stopPropagation();
      this.runTypograf(textarea);
    };

    typografButtonWrapper.appendChild(typografButton);
    textareaContainer.appendChild(textarea);
    textareaContainer.appendChild(typografButtonWrapper);

    const buttonsContainer = document.createElement('div');
    buttonsContainer.className = 'editor-inline__buttons';

    const cancelButton = document.createElement('button');
    cancelButton.className = 'editor-inline__button editor-inline__button--white';
    cancelButton.innerText = 'Отмена';
    cancelButton.onclick = () => {
      this.closeModal();
    };

    // Кнопка "Сохранить"
    const saveButton = document.createElement('button');
    saveButton.className = 'editor-inline__button';
    saveButton.innerText = 'Сохранить';
    saveButton.onclick = (e) => {
      e.stopPropagation();
      this.saveAndCloseModal(binding, textarea.value);
    };

    buttonsContainer.appendChild(cancelButton);
    buttonsContainer.appendChild(saveButton);

    modalContent.appendChild(title);
    modalContent.appendChild(textareaContainer);
    modalContent.appendChild(buttonsContainer);
    modalContent.appendChild(closeIcon);

    modalContainer.appendChild(modalContent);

    document.body.appendChild(modalContainer);
  },

  renderListModal() {
    document.addEventListener('keydown', this.handleKeyPress.bind(this));

    const modalContainer = document.createElement('div');
    this.modalContainer = modalContainer;
    modalContainer.className = 'editor-inline__modal';
    modalContainer.onclick = (e) => {
      e.stopPropagation();
      this.closeModal();
    };

    const modalContent = document.createElement('div');
    modalContent.className = 'editor-inline__mobal-content editor-inline__mobal-content--list';
    modalContent.onclick = (e) => {
      e.stopPropagation();
    };

    const closeIcon = document.createElement('div');
    closeIcon.className = 'editor-inline__close';
    closeIcon.innerHTML = '<span>&times;</span>';
    closeIcon.onclick = () => {
      this.closeModal();
    };

    const list = this.createTreeList(this.data);

    modalContent.appendChild(list);
    modalContent.appendChild(closeIcon);

    modalContainer.appendChild(modalContent);
    document.body.appendChild(modalContainer);
  },

  createTreeList(data, level = 0, path = '') {
    const div = document.createElement('div');
    div.style.paddingLeft = `${level * 20}px`;

    Object.keys(data).forEach((key) => {
      const currentPath = path ? `${path}.${key}` : key;
      const childDiv = document.createElement('div');
      childDiv.textContent = key;

      if (typeof data[key] === 'object' && data[key] !== null) {
        const nestedDiv = this.createTreeList(data[key], level + 1, currentPath);
        childDiv.appendChild(nestedDiv);
      }
      else {
        childDiv.textContent += `: ${data[key]}`;
        childDiv.style.cursor = 'pointer';
        childDiv.style.color = this.color;
        childDiv.style.paddingTop = '3px';
        childDiv.style.paddingBottom = '3px';
        childDiv.onclick = () => {
          this.closeModal();
          this.renderModal({ value: currentPath }, 'list');
        };
      }

      div.appendChild(childDiv);
    });

    return div;
  },

  runTypograf(textarea) {
    textarea.value = typograf(textarea.value);
  },

  setCirclePosition(el, circle) {
    const rect = el.getBoundingClientRect();

    const circleTop = rect.top + window.scrollY + (rect.height / 2);
    const circleLeft = rect.left + window.scrollX + (rect.width / 2);

    circle.style.top = `calc(${circleTop}px - 0.65rem)`;

    circle.style.left = `calc(${circleLeft}px - 0.65rem)`;
  },

  async renderElement(el, binding) {
    if (!store.data || !store.isAuthChecked) {
      el.innerHTML = `${binding.value}...`;
      store.addElement(el, binding);
      return;
    }

    if (this.isAdmin) {
      this.addObserver(el, binding);
      store.renderCircle(el, binding);
      el.setAttribute('data-editor-key', binding.value);
    }

    el.innerHTML = this.getPropertyByStringKey(binding.value);
  },

  addObserver(el) {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    };

    let timeoutId = null;

    el.editorObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            store.showCircle(el);
          }, 500);
        }
        else {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            store.hideCircle(el);
          }, 200);
        }
      });
    }, options);

    el.editorObserver.observe(el);
  },

  removeObserver(el) {
    if (el.editorObserver) {
      el.editorObserver.unobserve(el);
    }
  },

  async renderCircle(el, binding) {
    if (el.editorPointElement) {
      return;
    }
    const circle = document.createElement('div');
    circle.className = 'editor-inline__circle';

    circle.onclick = (e) => {
      e.stopPropagation();
      this.renderModal(binding);
    };

    document.body.appendChild(circle);

    el.editorPointElement = circle;
  },

  async removeCircle(el) {
    if (el.editorPointElement) {
      el.editorPointElement.remove();
    }

    el.editorPointElement = null;
  },

  showCircle(el) {
    if (!el.editorPointElement) {
      return;
    }

    this.setCirclePosition(el, el.editorPointElement);

    el.editorPointElement.style.display = 'block';
  },

  hideCircle(el) {
    if (!el.editorPointElement) {
      return;
    }

    el.editorPointElement.style.display = 'none';
  },
};

export default defineNuxtPlugin((nuxtApp) => {
  // Инициализируем $editorData в globalProperties
  if (!nuxtApp.vueApp.config.globalProperties.$editorData) {
    nuxtApp.vueApp.config.globalProperties.$editorData = ref({});
  }

  // Устанавливаем globalProperties в store для доступа из других методов
  store.globalProperties = nuxtApp.vueApp.config.globalProperties;

  nuxtApp.vueApp.directive('editor-inline', {
    async beforeMount(el, binding, vnode) {
      await store.authAndGetData(vnode.ctx.appContext.config.globalProperties);
    },
    mounted(el, binding) {
      store.renderElement(el, binding);
    },
    updated(el, binding) {
      store.renderElement(el, binding);

      if (!el.editorPointElement) {
        return;
      }

      store.setCirclePosition(el, el.editorPointElement);
    },
    beforeUnmount(el) {
      store.removeObserver(el);
      store.removeCircle(el);
    },
  });
});
